// Change #100438 - the filter-panel loop that used to live inline in
// SearchAndFilter's effect, moved here unchanged so a page that does its own
// list filtering (the customer Jobs tab) can apply the same panel filters
// instead of re-implementing them. Pure: takes a list, returns the filtered list.
import moment from "moment";

export const applyAllowedFilters = (dataList, allowedFilters) => {
  let filteredDataList = dataList;
  // Go allowedFilters and filter the data if there values not empty
  // If filterType is DateRange
  allowedFilters?.forEach((filter) => {
    if (filter?.useThisFilter) {
      if (filter.filterType === "DateRange") {
        if (filter?.filterValue?.startDate && filter?.filterValue?.endDate) {
          filteredDataList = filteredDataList?.filter((filterItem) => {
            // fillterItems including start and end date
            return (
              // inlucude time so that start starts at 00:00 and end at 23:59
              moment(filterItem[filter.filterProperty]).isSameOrAfter(
                filter?.filterValue?.startDate,
                "day"
              ) &&
              moment(filterItem[filter.filterProperty]).isSameOrBefore(
                filter?.filterValue?.endDate,
                "day"
              )
            );
          });
        }
      }
      //2 date range filter
      if (filter.filterType === "DateRange2Values") {
        if (filter?.filterValue?.startDate && filter?.filterValue?.endDate) {
          filteredDataList = filteredDataList?.filter((filterItem) => {
            return (
              moment(filterItem[filter.filterPropertyVal1]).isSameOrAfter(
                filter?.filterValue?.startDate,
                "day"
              ) &&
              moment(filterItem[filter.filterPropertyVal1]).isSameOrBefore(
                filter?.filterValue?.endDate,
                "day"
              ) &&
              moment(filterItem[filter.filterPropertyVal2]).isSameOrAfter(
                filter?.filterValue?.startDate,
                "day"
              ) &&
              moment(filterItem[filter.filterPropertyVal2]).isSameOrBefore(
                filter?.filterValue?.endDate,
                "day"
              )
            );
          });
        }
      }
      // If filterType is Select
      if (filter.filterType === "Select") {
        if (filter?.filterValue?.Id) {
          // Change #100653 - a filter may pass its own filterMatch(row, Id),
          // like Toggle does, when a plain equality test is not enough (a
          // flag that can be "0", null or missing all meaning "off").
          filteredDataList = filteredDataList?.filter((filterItem) => {
            if (typeof filter.filterMatch === "function") {
              return filter.filterMatch(filterItem, filter.filterValue.Id);
            }
            return (
              filterItem[filter.filterProperty] === filter?.filterValue?.Id
            );
          });
        }
      }
      // If filterType is SelectMultiple
      if (filter.filterType === "SelectMultiple") {
        if (filter?.filterValue.selectedItems?.length > 0) {
          filteredDataList = filteredDataList?.filter((filterItem) => {
            // for each selected item filter?.filterValue.selectedItems
            // filterItem . use dynamic key from filter.filterType
            return filter?.filterValue.selectedItems?.some((selectedItem) => {
              const rowValue = filterItem[filter.filterProperty];
              // Change #100308 - a row can carry several values (a job's
              // JobTag_Ids); it matches when any of them was picked.
              if (Array.isArray(rowValue)) {
                return rowValue
                  .map(String)
                  .includes(String(selectedItem.value));
              }
              return rowValue === selectedItem.value;
            });
          });
        }
      }
    }
    // Change #100413 - Toggle: when on, keep rows the filter matches. A
    // filter may pass its own filterMatch(row); otherwise a row matches when
    // filterProperty holds a real value (not empty, null or 0 - a Job_Id of
    // "0" means no job).
    if (filter?.useThisFilter && filter.filterType === "Toggle") {
      if (filter?.filterValue?.on === true) {
        const matches =
          typeof filter.filterMatch === "function"
            ? filter.filterMatch
            : (row) => {
                const v = row?.[filter.filterProperty];
                return (
                  v !== null &&
                  v !== undefined &&
                  v !== "" &&
                  v !== 0 &&
                  v !== "0"
                );
              };
        filteredDataList = filteredDataList?.filter(matches);
      }
    }
    // If filterType is NumberRange
    if (filter.filterType === "NumberRange") {
      if (filter?.filterValue?.min && filter?.filterValue?.max) {
        filteredDataList = filteredDataList?.filter((filterItem) => {
          // filterItem . use dynamic key from filter.filterType
          return (
            Number(filterItem[filter.filterProperty]) >=
              Number(filter?.filterValue?.min) &&
            Number(filterItem[filter.filterProperty]) <=
              Number(filter?.filterValue?.max)
          );
        });
      }
    }
  });
  return filteredDataList;
};

export default applyAllowedFilters;
